import React, { useState, useEffect } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import ProfileHeader from "../../../components/ProfileHeader";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import { getFaqs } from "../../../api/FaqsApi";


const Faqs = () => {

    const [data, setData] = useState([]);

    useEffect(() => {
       
        getFaqs().then((response) => {
        setData(response.data)
        })
        .catch((e) => {
        console.log("Error", e);
        });

    
     
      }, []);
    



  return (
    <Box sx={{background: {xs: 'linear-gradient(#5EB07F 100px, #F2F3F1 155px)', sm: '#F2F3F1'}, backgroundAttachment: 'fixed'}}>
    <ProfileHeader></ProfileHeader>
    <Box  p={2} >
    <Typography variant="h5" align="center" fontWeight="bold">
    Preguntas Frecuentes
    </Typography>
    </Box>
  

    <Box borderRadius={3} bgcolor="white" p={2} width='95%' margin="0 auto"  height="100%">
      {data?.map((item) => (
        <Accordion key={item.id}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body1" fontWeight="bold">{item.idFaq}. {item.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{item.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
    <ProfileBottomNav goBack={true}></ProfileBottomNav>
  </Box>
   
  );
};

export default Faqs;


